export default "__VITE_ASSET__85ecc33c__"